import React from "react";
import { useGetAllTimeGreatsLeadersQuery } from "../../store/api/mlbApi";
import { formatPlayerName } from "../../utils/textUtils";
import { CompareInspirationHost } from "./CompareInspiration";
import {
  MLB_COMPARE_PRESETS,
  getMlbCompareInspirationSections,
} from "./compareInspirationCatalog";

const MLB_INSPIRATION_SECTIONS = getMlbCompareInspirationSections();

const mlbDisplayName = (row, player) =>
  row.playerName || formatPlayerName(row) || player.name;

const MlbCompareInspiration = ({ selectedIds, onSelect, onSelectMatchup }) => (
  <CompareInspirationHost
    sections={MLB_INSPIRATION_SECTIONS}
    selectedIds={selectedIds}
    onSelect={onSelect}
    matchups={MLB_COMPARE_PRESETS}
    onSelectMatchup={onSelectMatchup}
    sport="mlb"
    getName={mlbDisplayName}
    useLeadersQuery={useGetAllTimeGreatsLeadersQuery}
  />
);

export default MlbCompareInspiration;
